import { useEffect } from 'react'
import { useRouteError } from 'react-router-dom'
import { ErrorFallback } from './error-boundary'
import { isChunkError, reloadForChunkError } from '@/lib/chunk-recovery'

export function RouteErrorBoundary() {
  const error = useRouteError()
  useEffect(() => {
    if (isChunkError(error)) reloadForChunkError()
  }, [error])

  // Always render a recovery screen, including while navigation is pending.
  // Throwing from the root route's errorElement escapes the router boundary.
  return <ErrorFallback error={error instanceof Error ? error : null} onReset={() => window.location.reload()} />
}
